const groupNames: string[] = [
    'Les archidégourdis',
    'Le collectif des dégourdis',
    'Les archifringuants',
    'Le collectif fringant ',
    'Les créastucieux',
    'Le collectif des astucieux',
    'Les archidélurés',
    'Les créa délurés',
    'Le collectif déluré',
    'La tribu espiègle ',
    'Le collectif malicieux',
    'Le collectif fripon',
    'Les archicostauds',
    'Les archipuissants',
    'Les mégacréa',
    'Le collectif des conquérants',
    'Les archibalèzes',
    'La tribu des balèzes',
    'Les archibaraqués ',
    'Le collectif éclatant',
    'Les éclatants créateurs',
    'Les archipétulants',
    'La tribu pétulante',
    'Les archipétillants',
    'Le collectif pétillant',
    'Les brillants créateurs ',
    'Les éminents créateurs',
    'Les étonnants créateurs',
    'L’étonnant collectif',
    'L’étonnante tribu ',
    'Les archifabuleux',
    'Les fabuleux créateurs',
    'Le collectif fabuleux',
    'La formidable tribu ',
    'Le collectif exquis',
    'La tribu des inventeurs',
    'Les archi inventifs',
    'La tribu perspicace',
    'Les ingénieux créateurs',
    'Le collectif ingénieux',
    'Les archienthousiastes',
    'Le collectif enthousiaste',
    'La tribu enthousiaste',
    'Les fervents créateurs',
    'La charmante tribu',
    'Les archimerveilleux',
    'Le collectif merveilleux',
    'La merveilleuse tribu',
    'La divine tribu',
    'La tribu qui pique',
    'La tribu prodigieuse',
    'Le collectif prodigieux',
    'Le collectif flamboyant',
    'Les archirrésistibles',
    'Les irrésistibles créateurs',
    'La tribu irrésistible',
    'Les créateurs intrépides',
    'Le collectif des intrépides',
    'La tribu intrépide',
    'Les truculents créateurs',
    'Le collectif truculent',
    'Les archicharismatiques',
    'Le collectif audacieux',
    'Les audacieux créateurs',
]

export { groupNames }
